document.addEventListener('DOMContentLoaded', () => {
  console.log("✅ Slider script loaded");

  const slider = document.querySelector('.slider__grid');
  const nextBtn = document.querySelector('button[name="next"]');
  const prevBtn = document.querySelector('button[name="prev"]');
  const items = document.querySelectorAll('.slider__item');

  if (!slider || !nextBtn || !prevBtn || items.length === 0) {
    console.error("❌ Slider or navigation buttons not found.");
    return;
  }

  let currentIndex = 0;
  const totalItems = items.length;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function getItemWidth() {
    return items[0].getBoundingClientRect().width;
  }

  function showSlide(index) {
    if (index < 0) {
      currentIndex = totalItems - 1; // Loop to last item
    } else if (index >= totalItems) {
      currentIndex = 0; // Loop to first item
    } else {
      currentIndex = index;
    }

    const offset = currentIndex * getItemWidth();
    slider.style.transform = `translateX(-${offset}px)`;
    slider.style.transition = "transform 0.4s ease-in-out";
  }

  // ✅ Fix Arrow Click Events
  nextBtn.addEventListener('click', () => {
    console.log("➡️ Next button clicked");
    showSlide(currentIndex + 1);
  });

  prevBtn.addEventListener('click', () => {
    console.log("⬅️ Prev button clicked");
    showSlide(currentIndex - 1);
  });

  // ✅ Fix Touch Swipe for Mobile
  slider.addEventListener('touchstart', (e) => {
    isDragging = true;
    startX = e.touches[0].clientX;
    prevTranslate = currentTranslate;
    slider.style.transition = "none";
  });

  slider.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const moveX = e.touches[0].clientX - startX;
    currentTranslate = prevTranslate + moveX;
    slider.style.transform = `translateX(${currentTranslate}px)`;
  });

  slider.addEventListener('touchend', (e) => {
    isDragging = false;
    const moveX = e.changedTouches[0].clientX - startX;

    // If swipe left, go next
    if (moveX < -50) {
      showSlide(currentIndex + 1);
    }
    // If swipe right, go prev
    else if (moveX > 50) {
      showSlide(currentIndex - 1);
    }
    // Snap back to original position if movement is too small
    else {
      showSlide(currentIndex);
    }
  });

  // ✅ Ensure proper width on resize
  window.addEventListener('resize', () => {
    console.log("🔄 Window resized, recalculating...");
    showSlide(currentIndex);
  });

  // ✅ Start with first slide
  showSlide(currentIndex);
});